import type { Currency } from './types';

const SYMBOLS: Record<Currency, string> = { USD: '$', EUR: '€' };

export function fmtCurrency(
  value: number,
  ccy: Currency,
  opts: { decimals?: number } = {}
): string {
  const decimals = opts.decimals ?? 0;
  const fixed = Math.round(Math.abs(value) * 10 ** decimals) / 10 ** decimals;
  const formatted = fixed.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return value < 0 ? `−${SYMBOLS[ccy]}${formatted}` : `${SYMBOLS[ccy]}${formatted}`;
}

export function fmtSignedCurrency(
  value: number,
  ccy: Currency,
  opts: { decimals?: number } = {}
): string {
  if (value === 0) return `${SYMBOLS[ccy]}0`;
  const sign = value > 0 ? '+' : '−';
  const decimals = opts.decimals ?? 0;
  const abs = Math.abs(value);
  const fixed = Math.round(abs * 10 ** decimals) / 10 ** decimals;
  const formatted = fixed.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${sign}${SYMBOLS[ccy]}${formatted}`;
}

export function fmtPct(fraction: number, opts: { decimals?: number } = {}): string {
  const decimals = opts.decimals ?? 1;
  return `${(fraction * 100).toFixed(decimals)}%`;
}

export function fmtSignedPct(fraction: number, opts: { decimals?: number } = {}): string {
  const decimals = opts.decimals ?? 1;
  if (fraction === 0) return `0.0%`;
  const sign = fraction > 0 ? '+' : '−';
  return `${sign}${(Math.abs(fraction) * 100).toFixed(decimals)}%`;
}
